export class LotCodeIwAttributes{
    isUsed:string;
    wip: string;
}